<div class="content-compact"
[ngClass]="AppSettings.IsRunningInSingularity ? 'content-compact-sso' : ''">
        <div class="consoleHeader" consoleHeaderOffset
        [ngClass]="AppSettings.IsRunningInSingularity ? 'consoleHeader-sso' : ''">
            <div class="row flex-nowrap">
            <!--Select Properties-->
            <div class="col-auto header_section pr-2">
                <div
                    *ngIf="lstProperties && lstProperties.length > 1"
                    ngbDropdown
                    #ddProperty="ngbDropdown"
                    class="dropdown-noarrow align-self-center"
                    placement="bottom-left"
                    autoClose="outside"
                    (openChange)="OnPropertySelectorOpened($event)"
                >
                    <button
                        type="button"
                        class="btn btn-link firstFilter"
                        title="{{'TITLE.TITLE_SELECT_PROPERTIES' | translate}}"
                        ngbDropdownAnchor
                        (click)="$event.stopPropagation(); ddProperty.toggle()"
                        [ngClass]="(RequestModel.Properties.length > 1 ? 'propSelected' : '')"
                    >
                        <i class="ksv-icon-building"></i>
                    </button>
                    <div
                        class="dropdown-menu scrollable-dropdown-menu"
                        ngbDropdownMenu
                    >
                        <div
                            class="dropdown-header"
                            style="padding: 0.5rem 2.75rem"
                        >
                            <input
                                class="form-check-input"
                                type="checkbox"
                                [checked]="IsAllPropertiesSelected()"
                                [indeterminate]="IsSomePropertiesSelected()"
                                (change)="OnPropertyToggle($event)"
                                id="chk_prop_master_recurrence"
                            />

                            <label
                                class="form-check-label text-nowrap"
                                for="chk_prop_master_recurrence">
                                {{"LBL.SELECT_PROPERTIES" | translate}}
                            </label>
                        </div>

                        <div class="px-4">
                            <div
                                class="form-check"
                                *ngFor="let row of lstProperties"
                            >
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="chk_prop_{{row.PropertyId}}"
                                    [value]="row.PropertyId"
                                    [checked]="IsPropertySelected(row.PropertyId)"
                                    (change)="OnPropertySelected(row.PropertyId, $event)"
                                />
                                <label
                                    class="form-check-label text-nowrap"
                                    for="chk_prop_{{row.PropertyId}}"
                                >{{row.PropertyName}}</label
                                >
                            </div>
                        </div>
                        <div class="dropdown-divider"></div>
                        <div class="px-4">
                            <button
                                class="btn btn-secondary btn-sm"
                                type="button"
                                (click)="OnPropertyChange(); ddProperty.close()"
                                translate
                            >
                                BTN.BTN_SAVE
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Select Status -->
            <div class="col-auto topFilters header_section headerlink-2line">
                <a *ngFor="let row of PropStatModel"
                   href="javascript:{}"
                   (click)="OnTopFilterClick(row.Id)"
                   [ngClass]="{'active': RequestModel.StatusCode == row.Id}">
                    <div class="topFilter_Label text-center" translate>{{row.Label}} </div>
                    <div class="small text-center">({{row.Value}})</div>
                </a>
            </div>
            <!-- Search -->
            <div class="col-auto d-flex align-items-center header_section">
                <div class="searchFilterResult">
                    <input
                        type="text"
                        class="form-control searchFilter_Text"
                        placeholder="{{'PH.PH_SEARCH' | translate}}"
                        [placement]="['bottom']"
                        [(ngModel)]="KeywordSearch"
                        [ngbTypeahead]="SearchStringTypeahead"
                        [editable]="false"
                        [resultTemplate]="SearchResult"
                        (selectItem)="OnSearchFilter($event)"
                        [inputFormatter]="SearchFilterDisplayText"
                    />
                </div>
            </div>
            <!-- Grouping -->
            <div class="col-auto d-flex align-items-center header_section">
                <div class="w-auto"
                    title="{{'TITLE.TITLE_GROUP_BY' | translate}}">
                    <select class="custom-select"
                        [(ngModel)]="RequestModel.GroupBy"
                        (change)="OnGroupingChanged()">
                        <option *ngFor="let row of GroupTypes" [ngValue]="row.Id">
                            {{row.Name | uppercase | translate}}
                        </option>
                    </select>
                </div>
                <div class="align-items-center" *ngIf="RequestModel.GroupBy">
                    <div
                        class="ml-4 pointer"
                        (click)="OnGroupingCleared()"
                        *ngIf="RequestModel.GroupBy"
                    >
                        <strong><i class="fas fa-times fa-lg mr-2"></i></strong
                        >Clear Grouping
                    </div>
                </div>
            </div>
            <!-- Filters -->
            <div class="col-auto d-flex header_section align-items-center px-4"
                [ngClass]="HasFilters() ? 'backHightlight':''">
                <div class="pointer"
                    (click)="OnFilterOpen()"
                    title="{{'TITLE.TITLE_FILTERS' | translate}}">
                    <i class="fas fa-filter"></i>
                </div>
                <ng-container *ngIf="RequestModel && RequestModel.StatusCode !== 'Y' && RequestModel.StatusCode !== 'D'">
                    <div class="ml-4 pointer d-flex align-items-center">
                        <select #months class="form-control form-control-sm col p-0" (change)="OnMonthChange(months.value)">
                            <option *ngFor="let month of ['All','1','2','3','4','5','6','7','8','9','10','11','12']" [value]='month'>{{month}}</option>
                        </select>
                        <span class="ml-1" translate>LBL.MONTHS</span>
                    </div>
                </ng-container>
                <ng-container *ngIf="HasFilters()">
                    <div class="ml-4 pointer"
                         (click)="OnFilterClear()">
                        <i class="fas fa-times fa-lg mr-2"></i
                        >{{'TITLE.TITLE_CLEAR_FILTER' | translate}}
                    </div>
                </ng-container>
            </div>
            <!-- Console Actions -->
            <div class="col d-flex justify-content-end">
<!--                <div class="header_section align-items-center px-3">-->
<!--                    <div class="pointer" (click)="OnExportToExcel()" title="{{'TITLE.TITLE_EXPORT_EXCEL' | translate}}"><i class="far fa-lg fa-file-excel"></i></div>-->
<!--                </div>-->
                <div class="header_section align-items-center px-3">
                    <div class="pointer" (click)="OnLegendModalOpen()" title="{{'TITLE.TITLE_LEGENDS' | translate}}"><i class="fa fa-lg fa-key fa-fw"></i></div>
                </div>
                <div class="header_section align-items-center px-3">
                    <div class="pointer" (click)="OnRefreshClick()" title="{{'TITLE.TITLE_REFRESH' | translate}}"><i class="fa fa-lg fa-sync-alt"></i></div>
                </div>
            </div>
        </div>
        </div>
    <div class="jobconsole-body">
        <!-- Loader -->
        <sk-wave [isRunning]="IsSubmitting"></sk-wave>
        <div>
            <!-- No Grouping -->
            <div [hidden]="RequestModel.GroupBy !== _RecurrenceSearch_GroupBy.None && !IsSubmitting">
                <RecurrenceSearchResult #grdSearchResult
                    [RequestModel]="RequestModel"
                    (onSelected)="OnSelectedChange($event)"
                ></RecurrenceSearchResult>
            </div>
            <!-- Groups -->
            <ng-container *ngIf="RequestModel.GroupBy !== _RecurrenceSearch_GroupBy.None && !IsSubmitting && ResultModel && ResultModel.Result">
                <div class="row"
                    *ngFor="let row of ResultModel.Result; let index = index;">
                    <div class="col" *ngIf="index < 100">
                        <RecurrenceSearchGroup
                            [RequestModel]="RequestModel"
                            [Model]="row"
                        ></RecurrenceSearchGroup>
                    </div>
                </div>
                <!-- Too Many Groupings -->
                <div class="d-flex justify-content-center noRecords"
                    *ngIf="ResultModel.Result.length >= 100" translate>
                    LBL.DISCLAIMER_GROUPING_LIMIT
                </div>
            </ng-container>
            <!-- No Records -->
            <div class="noRecords"
                *ngIf="FilterModel != null && RequestModel.GroupBy != _RecurrenceSearch_GroupBy.None && ResultModel == null && !IsSubmitting">
                <span translate>LBL.NO_RECORD_FOUND</span>
            </div>
        </div>
    </div>
</div>


<ng-template #SearchResult let-row="result" let-t="term" class="">
    <div class="d-flex justify-content-between align-items-center">
        <div class="w-auto d-flex align-items-center">
            <div
                class="w-auto mr-2"
                title="{{'TITLE.TITLE_SEARCH' | translate}}"
            >
                <div class="searchIcon"><i class="fas fa-search"></i></div>
            </div>
            <div class="w-auto mr-2">{{t}}</div>
        </div>
        <div class="w-auto">
            <div class="entityName text-muted">
                {{'ENTITIES.ENTITIES_' + row.EntityName | uppercase |
                translate}}
            </div>
        </div>
    </div>
</ng-template>

<ng-template #recurrenceKey let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6 class="modal-title" translate>TITLE.TITLE_KEY</h6>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body container-fluid">
        <div class="row">
            <div class="col-6 pr-0 d-flex">
                <div class="col-1 px-0"><i class="far fa-file-excel"></i></div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_EXCEL_EXPORT
                </div>
            </div>
            <div class="col-6 d-flex">
                <div class="col-1 px-0"><i class="fas fa-sync-alt"></i></div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_REFRESH
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 pr-0 d-flex">
                <div class="col-1 px-0 text-center">
                    <div class="statusIcon-Standard status-ACTIVE" title=""></div>
                </div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_ACTIVE_RECURRENCE
                </div>
            </div>
            <div class="col-6 d-flex">
                <div class="col-1 px-0 text-center">
                    <div class="statusIcon-Standard status-EXPIRED" title=""></div>
                </div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_EXPIRED_RECURRENCE
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 pr-0 d-flex">
                <div class="col-1 px-0 text-center">
                    <div class="statusIcon-Standard status-DELETED border-dark" title=""></div>
                </div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_DELETED_RECURRENCE
                </div>
            </div>
            <div class="col-6 d-flex">
                <div class="col-1 px-0"><i class="fas fa-map-marker-alt"></i></div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_LOCATION
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 pr-0 d-flex">
                <div class="col-1 px-0"><i class="fas fa-sort"></i></div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_SORT
                </div>
            </div>
            <div class="col-6 d-flex">
                <div class="col-1 px-0"><i class="fas fa-bell"></i></div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_NOTIFICATION
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex px-0">
                <div class="statusIcon col-1 connectionIcon"><i class="ksv-icon-connection-off statusIcon-Error"></i>
                </div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_CONNECTION_FAIL
                </div>
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="statusIcon col-1 connectionIcon"><i class="ksv-icon-connection-on statusIcon-Sucess"></i>
                </div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_CONNECTION_SUCCESS
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex px-0">
                <div class="col-1 usr-info"><i class="fas fa-info-circle"></i></div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_USR_INFO
                </div>
            </div>
            <div class="col-6 pl-0 d-flex">
                &nbsp;
            </div>
        </div>
    </div>
    <div class="modal-footer ">
        <button type="button" class="btn btn-primary mr-3" (click)="c('close')" translate>BTN.BTN_OK</button>
    </div>
</ng-template>

<JobFilter
    #jobFilter
    [EnabledFilters]="RecurrenceFilters"
    (ApplyFilter)="didApplyFilters($event)">
</JobFilter>

<RecurrencePopover
    [Selected]="recurrenceConsoleService.SelectedRecurrence"
    (Deleted)="OnRowDelete($event)">
</RecurrencePopover>
